import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Contact.css';

gsap.registerPlugin(ScrollTrigger);

const socials = [
  {
    name: 'Email',
    handle: 'Pratik7230.1@gmail.com',
    href: 'mailto:Pratik7230.1@gmail.com',
    color: '#6c63ff',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="2" y="4" width="20" height="16" rx="2" />
        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
      </svg>
    ),
  },
  {
    name: 'GitHub',
    handle: 'github.com/Pratik7230',
    href: 'https://github.com/Pratik7230',
    color: '#00d4ff',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0 1 12 6.844a9.59 9.59 0 0 1 2.504.337c1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0 0 22 12.017C22 6.484 17.522 2 12 2Z" />
      </svg>
    ),
  },
  {
    name: 'LinkedIn',
    handle: 'in/pratikpatil7230',
    href: 'https://www.linkedin.com/in/pratikpatil7230/',
    color: '#ff6b6b',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
];

function Contact() {
  const sectionRef  = useRef(null);
  const labelRef    = useRef(null);
  const titleRef    = useRef(null);
  const socialsRef  = useRef([]);
  const formRef     = useRef(null);
  const [formState, setFormState] = useState({ name: '', email: '', message: '' });
  const [sending, setSending]     = useState(false);
  const [sent, setSent]           = useState(false);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.set([labelRef.current, titleRef.current, formRef.current], { opacity: 0 });
      gsap.set(socialsRef.current.filter(Boolean), { opacity: 0, x: -30 });

      gsap.timeline({
        scrollTrigger: { trigger: sectionRef.current, start: 'top 80%', toggleActions: 'play none none none' },
      })
      .to(labelRef.current, { opacity: 1, x: 0, duration: 0.6, ease: 'power3.out' })
      .to(titleRef.current, { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }, '-=0.3')
      .to(socialsRef.current.filter(Boolean), { opacity: 1, x: 0, duration: 0.5, stagger: 0.12, ease: 'power3.out' }, '-=0.3')
      .to(formRef.current, { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }, '-=0.5');
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  const handleChange = (e) => setFormState({ ...formState, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);

    const recipient = 'Pratik7230.1@gmail.com';
    const subject = `Portfolio Contact from ${formState.name}`;
    const body = [
      `Name: ${formState.name}`,
      `Email: ${formState.email}`,
      '',
      formState.message,
    ].join('\n');

    const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;

    setSending(false);
    setSent(true);
    setFormState({ name: '', email: '', message: '' });
    setTimeout(() => setSent(false), 4000);
  };

  return (
    <section id="contact" className="contact" ref={sectionRef}>
      <div className="contact-bg-orb" />
      <div className="container">
        <div ref={labelRef} className="section-label">Let's Connect</div>
        <h2 ref={titleRef} className="section-title">
          Get In <span className="gradient-text">Touch</span>
        </h2>
        <p className="section-subtitle">Open to new projects, ideas, or just a friendly chat.</p>

        <div className="contact-layout">
          {/* ─── Left ─── */}
          <div className="contact-left">
            <p className="contact-intro">
              I'm always open to discussing new projects, creative ideas, or opportunities
              to be part of your vision. Let's create something amazing together!
            </p>

            <div className="social-links">
              {socials.map((s, i) => (
                <a
                  key={s.name}
                  ref={(el) => (socialsRef.current[i] = el)}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-card"
                  onMouseEnter={(e) => gsap.to(e.currentTarget, { x: 6, duration: 0.3, ease: 'power2.out' })}
                  onMouseLeave={(e) => gsap.to(e.currentTarget, { x: 0, duration: 0.4, ease: 'elastic.out(1,0.8)' })}
                >
                  <div className="social-icon" style={{ color: s.color, background: `${s.color}12`, border: `1px solid ${s.color}25` }}>
                    {s.icon}
                  </div>
                  <div className="social-info">
                    <span className="social-name" style={{ color: s.color }}>{s.name}</span>
                    <span className="social-handle">{s.handle}</span>
                  </div>
                  <div className="social-arrow">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                  </div>
                </a>
              ))}
            </div>
          </div>

          {/* ─── Right: Form ─── */}
          <div ref={formRef} className="contact-form-wrap glass-card">
            <h3 className="form-heading">Send a Message</h3>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-field">
                  <label htmlFor="name">Your Name</label>
                  <input id="name" type="text" name="name" placeholder="John Doe" value={formState.name} onChange={handleChange} required />
                </div>
                <div className="form-field">
                  <label htmlFor="email">Email Address</label>
                  <input id="email" type="email" name="email" placeholder="john@example.com" value={formState.email} onChange={handleChange} required />
                </div>
              </div>
              <div className="form-field">
                <label htmlFor="message">Message</label>
                <textarea id="message" name="message" placeholder="Tell me about your project..." rows={5} value={formState.message} onChange={handleChange} required />
              </div>
              <button type="submit" className="form-submit" disabled={sending || sent}>
                {sent ? (
                  <span>✓ Message Sent!</span>
                ) : sending ? (
                  <><span className="spinner" />Sending...</>
                ) : (
                  <>
                    <span>Send Message</span>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
                    </svg>
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
